import React from "react";

const AppleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 814 1000">
    <path
      d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76.5 0-103.7 40.8-165.9 40.8s-105.6-57.8-155.5-127.4c-58.3-81.1-105.9-207.6-105.9-328.5 0-193.2 125.7-296 249.4-296 65.8 0 120.8 43.4 162.1 43.4 39.2 0 100.2-46 175.6-46 28.3 0 130.1 2.6 197.4 96.5zm-270.7-87.6c31.3-37.1 53.5-88.6 53.5-140.1 0-7.1-.7-14.3-2-20.7-51 1.9-110.6 33.9-147 76.4-28.3 31.9-56.3 83.4-56.3 135.6 0 7.8.9 15.6 1.3 18.1 2.6.4 6.5.7 10.4.7 45.7 0 102.5-30.4 140.1-70z"
      fill="#000000"
    />
  </svg>
);

export default AppleIcon;
